/**
 * TanStack Query hooks for `auto-block-publisher-when-fraud-threshold-hit`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	summary,
	autoBlockPublisherWhenFraudThresholdHitQueryKeys,
	type BlockStatus,
	type CreateBlockBody,
	type CreateBlockResponse,
	type ListBlockResponse,
	type SummaryResponse,
} from "./api";

export function useAutoBlockList(params?: {
	status?: BlockStatus;
	publisher_id?: string;
}): UseQueryResult<ListBlockResponse, Error> {
	return useQuery({
		queryKey: autoBlockPublisherWhenFraudThresholdHitQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useAutoBlockSummary(): UseQueryResult<SummaryResponse, Error> {
	return useQuery({
		queryKey: autoBlockPublisherWhenFraudThresholdHitQueryKeys.summary(),
		queryFn: summary,
	});
}

export function useAutoBlockCreate(): UseMutationResult<
	CreateBlockResponse,
	Error,
	CreateBlockBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: autoBlockPublisherWhenFraudThresholdHitQueryKeys.all,
			});
		},
	});
}
